module.exports = __webpack_public_path__ + "static/media/person.c243b6b1.svg";